<template>
  <div class="login">
    <v-container>
      <v-layout row justify-center>
        <v-flex xs4>
          <v-card>
            <v-card-title>
              <h1>Login to Schedule Manager</h1>
            </v-card-title>

            <v-card-text>
              <v-form ref="loginForm">
                <v-text-field label="Email" name="email" v-model.trim="email" prepend-icon="email"
                              :rules="emailRules" @keyup.native="inputKeyPress" />
                <v-text-field label="Password" name="password" v-model="password" prepend-icon="lock" type="password"
                              :rules="passwordRules" @keyup.native="inputKeyPress" />
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-progress-circular indeterminate class="ml-1" v-if="loading" />
              <v-spacer />

              <v-btn right class="success mb-2" @click="submit">
                <span>Login</span>
                <v-icon class="ml-2">arrow_forward</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-snackbar v-model="snackbar" :top=true>
      <span class="red--text">Invalid username or password!</span>
      <v-btn flat color="pink" @click="snackbar = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {auth} from 'firebase/app';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      snackbar: false,
      loading: false,
      emailRules: [
        value => value.length >= 1 || 'Please enter your email'
      ],
      passwordRules: [
        value => value.length >= 1 || 'Please enter your password'
      ]
    };
  },
  methods: {
    submit() {
      if (this.$refs.loginForm.validate()) {
        this.loading = true;

        auth().signInWithEmailAndPassword(this.email, this.password).then(user => {
          this.$store.commit('setCurrentUser', user);
          this.$store.commit('setIsAuthenticated', true);

          this.$router.back();
          this.loading = false;
        }).catch(() => {
          this.snackbar = true;
          this.loading = false;
        });
      }
    },
    inputKeyPress(event) {
      if (event.key === 'Enter') {
        this.submit();
      }
    }
  }
};
</script>

<style scoped>

</style>
